import ApiRequester from './ApiRequester';

export default class {
  constructor() {
    this.apiUrls = {
      postLogin: '/login',
    };
    this.lastCall = 0;
    this.currentCall = 0;
    this.rw = null;
    return this;
  }
  postLogin(payload) {
    const rw = new ApiRequester();
    rw.method = 'post';
    rw.data = payload;
    rw.url = this.apiUrls.postLogin;
    return rw.submitRequest();
  }
}
